document.addEventListener("DOMContentLoaded", () => {
	const openButtons = document.querySelectorAll(".js-showreel");
	const closeButtons = document.querySelectorAll(".js-closeModal");
	const soundSwitchButton = document.querySelector(".js-soundSwitcher");
	const soundIcon = soundSwitchButton?.querySelector(".js-soundIcon");
	const showreelPreviewVideo = document.querySelectorAll(".js-showreelVideo");

	function isSafari() {
		return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	}

	let fullPlayer;
	let fullVideoIframe;

	const originalSrc = document
		.querySelector(".js-fullShowreelVideo")
		?.getAttribute("data-src");

	async function initPlayer() {
		fullVideoIframe = document.querySelector(".js-fullShowreelVideo");

		if (fullVideoIframe) {
			fullPlayer = new Vimeo.Player(fullVideoIframe);
			await fullPlayer.setCurrentTime(0);
		}
	}

	const updateSoundIcon = async () => {
		if (!fullPlayer || !soundIcon) return;
		const isMuted = await fullPlayer.getMuted();
		isMuted
			? soundIcon.classList.add("is-off")
			: soundIcon.classList.remove("is-off");
	};

	const openShowreelVideo = async (e) => {
		e.preventDefault();
		const btn = e.currentTarget;
		const modalSelector = btn.getAttribute("data-modal");
		const modal = document.querySelector(modalSelector);
		soundIcon.classList.remove("is-off");
		if (!modal) return;

		document.body.style.overflow = "hidden";
		modal.classList.add("active");
		document.body.classList.add("modal-open");

		const iframe = modal.querySelector(".js-fullShowreelVideo");
		const dataSrc = iframe?.getAttribute("data-src");

		if (iframe && dataSrc) {
			let finalSrc = originalSrc || dataSrc;

			if (isSafari()) {
				if (!finalSrc.includes("muted=1")) {
					finalSrc += "&muted=1";
				}
			} else {
				finalSrc += "&muted=0";
			}

			iframe.setAttribute("src", finalSrc);
		}

		if (isSafari()) {
			soundIcon.classList.add("is-off");
		} else {
			soundIcon.classList.remove("is-off");
		}

		setTimeout(async () => {
			await initPlayer();

			if (isSafari()) {
				await fullPlayer.setMuted(true);
			} else {
				await fullPlayer.setMuted(false);
			}
		}, 300);
	};

	openButtons.forEach((btn) => {
		btn.addEventListener("click", openShowreelVideo);
	});

	showreelPreviewVideo.forEach((item) =>
		item.addEventListener("click", openShowreelVideo)
	);

	closeButtons.forEach((btn) => {
		btn.addEventListener("click", async (e) => {
			soundIcon.classList.add("is-off");
			e.preventDefault();

			const modal = btn.closest(".showreel-modal");

			if (!modal) return;

			document.body.style.overflow = "auto";
			modal.classList.remove("active");
			document.body.classList.remove("modal-open");

			const iframe = modal.querySelector(".js-fullShowreelVideo");
			if (iframe) iframe.setAttribute("src", "");
		});
	});

	if (soundSwitchButton && soundIcon) {
		soundSwitchButton.addEventListener("click", async (e) => {
			e.preventDefault();
			if (!fullPlayer) return;

			const muted = await fullPlayer.getMuted();
			await fullPlayer.setMuted(!muted);
			await updateSoundIcon();
		});
	}
});
